/*
 * Chat messages are stored as small pieces of HTML: the old composer saved
 * what the editor held ("Hi&nbsp;", "line<br>line"), and the player app
 * renders them that way. These two helpers keep both sides plain and safe.
 */

/* Stored message -> text to show. DOMParser builds an inert document: no
   scripts run and no images load, so nothing in a message can act. */
export function toPlain(stored) {
  const s = String(stored == null ? '' : stored)
  if (s.indexOf('<') === -1 && s.indexOf('&') === -1) return s
  try {
    const doc = new DOMParser().parseFromString(s.replace(/<br\s*\/?>/gi, '\n'), 'text/html')
    return (doc.body.textContent || '').replace(/ /g, ' ')
  } catch (e) {
    return s.replace(/<[^>]*>/g, '')
  }
}

/* Text typed by the scout -> what is stored. Escaped, so the player app
   shows exactly what was typed and never renders it as markup. */
export function toStored(text) {
  return String(text == null ? '' : text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\r?\n/g, '<br>')
}
